import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const usePageSections = (page, fallbackTypes) => {
  const [sections, setSections] = useState(null);
  useEffect(() => {
    axios
      .get(`${API}/sections`, { params: { page } })
      .then((r) => setSections(r.data))
      .catch(() => setSections(fallbackTypes.map((type) => ({ id: type, type, content: {} }))));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);
  return sections;
};

export default usePageSections;
